import { clientOnly } from '~/decorators'

import { containerScoped } from '~/decorators/dependency-container'

@containerScoped()
export default class UrlOpenerService {
  @clientOnly
  openUrlInNewTab(url: string) {
    const a: HTMLAnchorElement = document.createElement('a')
    a.setAttribute('href', url)
    a.setAttribute('target', '_blank')
    a.click()
    a.remove()
  }
}
